var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","transform":"translate(2 2)"},[React.createElement("circle",{"cx":"7","cy":"7","r":"7","key":0}),React.createElement("path",{"d":"M7 3v4.5L10 9","key":1})]));
}

Clock.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Clock;

Clock.default = Clock;
